<template>
  <div>
    <UpdateRecord v-if="currentNode.clazz === 'updateRecord'"/>
    <ScriptTask v-else-if="currentNode.clazz === 'scriptTask'"/>
    <MailTask v-else-if="currentNode.clazz === 'mailTask'"/>
    <UserTask v-on="$listeners" v-else-if="currentNode.clazz === 'userTask'"/>
    <Decision v-on="$listeners" v-else-if="currentNode.clazz === 'decision'" />
    <Comment v-on="$listeners" v-else-if="currentNode.clazz === 'comment'" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UpdateRecord from './UpdateRecord'
import ScriptTask from './ScriptTask'
import MailTask from './MailTask'
import UserTask from './UserTask'
import Decision from './Decision'
import Comment from './Comment'

export default {
  components: {
    UpdateRecord,
    ScriptTask,
    MailTask,
    UserTask, 
    Decision,
    Comment
  },
  computed: {
    ...mapState('diagramBuilder', [
      'currentNode'
    ])
  }
}
</script>
